function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { T, useTranslate } from 'shared/helper/translate';
var Voucher = function Voucher(_ref) {
  var useVoucher = _ref.useVoucher,
    verifyVoucher = _ref.verifyVoucher;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    voucherCode = _useState2[0],
    setVoucherCode = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    voucherError = _useState4[0],
    setVoucherError = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    voucherSuccess = _useState6[0],
    setVoucherSuccess = _useState6[1];
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    setVoucherError(null);
    verifyVoucher(encodeURIComponent(voucherCode)).then(function (response) {
      if (response.error) {
        setVoucherError(response.error);
      } else if (response.voucher) {
        useVoucher(response.voucher);
        setVoucherSuccess(true);
      }
    });
  };
  var handleVoucherCodeChange = function handleVoucherCodeChange(e) {
    setVoucherCode(e.target.value.trim());
  };
  var resetVoucherCode = function resetVoucherCode() {
    setVoucherCode('');
    setVoucherError(null);
    setVoucherSuccess(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, voucherSuccess ? null : /*#__PURE__*/React.createElement("div", {
    className: "voucher-input"
  }, /*#__PURE__*/React.createElement("label", {
    className: "voucher-heading"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Voucher code"
  })), /*#__PURE__*/React.createElement("div", {
    className: "row m-0 mb-1"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-control col-md-8",
    onChange: handleVoucherCodeChange
  }), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Use Voucher'),
    className: "btn btn-squared btn-primary use-voucher col-md-4",
    onClick: handleSubmit,
    type: "button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Use Voucher"
  })))), voucherError ? /*#__PURE__*/React.createElement("em", {
    className: "error"
  }, /*#__PURE__*/React.createElement(T, {
    source: voucherError
  })) : null, voucherSuccess ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("em", {
    className: "success"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "Voucher **%(code)s** has been successfully applied.",
    params: {
      code: voucherCode
    }
  })), /*#__PURE__*/React.createElement("em", {
    className: "success"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Use a different voucher code'),
    type: "button",
    onClick: resetVoucherCode
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "Use a different voucher code"
  })))) : null);
};
export default Voucher;